import('./src/index.js');